import React from 'react';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
import REST from 'go/requests/rest';
import {Grid, Card, Header, Divider, Loader} from 'semantic-ui-react';
import {
  API_ORG_PROGRAM_GET_SUCCESS,
  API_PROGRAM_LIST_GET_SUCCESS,
  API_SUBORG_ORG_PROGRAM_GET_SUCCESS,
} from 'common/types';
import {ENTITY_MAP, ROLE_MAP} from 'app-ui-componentlibrary/dist/common/constants';
import ApiActions from 'go/actions/api';
import {ISOToDisplayDate} from 'common/utils';
import _ from 'lodash';
import moment from 'moment';
import {Toggle} from 'componentLibrary';

const NEW_SUBORG_GRANT_ROLE_PERMISSIONS = [
  ROLE_MAP.SUBAUTHREP.code,
  ROLE_MAP.SUBMEMBER.code,
];

const NEW_GRANT_ROLE_PERMISSIONS = [
  ROLE_MAP.ORGAOR.code,
  ROLE_MAP.ORGMEMBER.code,
  ROLE_MAP.ORGPGMMEMBER.code,
  ROLE_MAP.ORGGRNTWRITER.code,
  ROLE_MAP.ORGFINMEMBER.code,
];

export class ApplyNewGrantCard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      programs: [],
      categories: [],
    };

    this.permObj = _.reduce(
      props.permissions,
      (result, permission) => {
        const [entityTypeId, , roleId] = permission.split(':');
        if (_.indexOf(result.types, entityTypeId) === -1) {
          result.entityTypes.push(entityTypeId);
        }
        if (_.indexOf(result.roles, roleId) === -1) {
          result.roles.push(roleId);
        }
        return result;
      },
      {entityTypes: [], roles: []}
    );
  }

  refreshData() {
    const {
      token,
      getOrgPrograms,
      getProgramInfo,
      getSuborgOrgPrograms,
      userOrgs,
    } = this.props;

    const samGovOrgs = _.filter(userOrgs, (org) => org.isManuallyAdded === 'N');

    const isNewGrantAllowedForRole =
      _.intersection(NEW_GRANT_ROLE_PERMISSIONS, this.permObj.roles).length > 0;
    if (
      _.intersection(this.permObj.entityTypes, [
        ENTITY_MAP.PROGRAM_ORGANIZATION.code,
        ENTITY_MAP.ORGANIZATION.code,
      ])
    ) {
      getOrgPrograms(token)
        .then((res) => {
          if (res && res.hasResults) {
            const programs = res.payload.organizationPrograms;
            const ids = new Set(_.map(programs, 'programId'));

            // filter out sub-organization permissions, and filter out non-SamGov orgs (that do not have a programId)
            let orgProgram = [];
            _.filter(programs, (program) => {
              if (!_.has(program, 'parentOrganizations')) {
                orgProgram.push({
                  orgId: program.organizationId,
                  programId: program.programId,
                });
              }
            });

            const params = Array.from(ids).toString();

            return getProgramInfo(token, params).then((res) => {
              if (res) {
                const programs = res.payload;
                const isNewSubOrgGrantAllowedForRole =
                  _.intersection(NEW_SUBORG_GRANT_ROLE_PERMISSIONS, this.permObj.roles)
                    .length > 0;

                let categoriesArray = [];
                const manageTeamOrgSubOrgToggle = _.get(
                  this.props,
                  'toggles',
                  []
                ).includes('manageTeamOrgSubOrg');
                _.map(programs, (prog) => {
                  if (
                    manageTeamOrgSubOrgToggle
                      ? isNewSubOrgGrantAllowedForRole === true &&
                        prog.subapplicationFlag === true &&
                        !categoriesArray.includes(prog.programCategoryName)
                      : prog.subapplicationFlag === true &&
                        !categoriesArray.includes(prog.programCategoryName)
                  ) {
                    return categoriesArray.push({
                      categoryId: prog.programCategoryId,
                      categoryName: prog.programCategoryName,
                    });
                  }
                });

                const categories = _.uniqWith(categoriesArray, _.isEqual);

                this.setState({
                  loading: false,
                  programs,
                  allOrgPrograms: res.payload,
                  orgProgram,
                  categories,
                });
              }
            });
          } else {
            this.setState({loading: false});
          }
        })
        .then(() => {
          // Check the permissions
          if (!isNewGrantAllowedForRole) {
            return Promise.resolve();
          }

          const {token} = this.props;
          const {orgProgram} = this.state;

          // Get funding opportunity for program
          // Remove program(s) if they belong ONLY not SamGov organization
          const samGovOrgsIds = _.map(samGovOrgs, 'organizationId');

          let programIds = _.chain(orgProgram)
            .filter((prog) => _.indexOf(samGovOrgsIds, prog.orgId) > -1)
            .map('programId')
            .uniq()
            .value();

          const requests = _.map(programIds, (programId) =>
            REST.fundingOpportunity.getFundingOpportunitiesForProgram(token, programId)
          );
          return Promise.all(requests);
        })
        .then((foResponses) => Promise.all(_.map(foResponses, (resp) => resp.json())))
        .then((respJson) => {
          const fundingOpportunities = _.chain(respJson)
            // TODO: Result/payload wrapper clean up
            .map('payload')
            .map((resp) => JSON.parse(resp))
            .map('fundingOpportunities')
            .flatten()
            .value();
          return this.setState({fundingOpportunities});
        });
    }
  }

  componentDidUpdate(prevProps) {
    if (!_.isEqual(prevProps.userOrgs, this.props.userOrgs)) {
      this.refreshData();
    }
  }

  componentDidMount() {
    const {userOrgs} = this.props;
    if (userOrgs) {
      this.refreshData();
    }
  }

  renderObjects(objects) {
    if (objects.length) {
      return (
        <Grid>
          {_.map(objects, (obj) => {
            return (
              <Grid.Row key={'grid-row-' + obj.id}>
                <Grid.Column key={'grid-col-' + obj.id} width={10}>
                  <strong>{obj.displayName}</strong>
                  {obj.aplcnStartDate ? (
                    <React.Fragment>
                      <br />
                      Application period: <br />
                      {obj.aplcnStartDate} - {obj.aplcnEndDate}
                    </React.Fragment>
                  ) : (
                    ''
                  )}
                </Grid.Column>
                <Grid.Column key={'start-here-link-' + obj.id} width={6}>
                  <Link
                    id={'startLink' + obj.id}
                    to={obj.link}
                    title={`${obj.linkDisplay} ${obj.displayName}`}
                  >
                    {obj.linkDisplay}
                  </Link>
                </Grid.Column>
              </Grid.Row>
            );
          })}
        </Grid>
      );
    }
  }

  render() {
    const {loading, fundingOpportunities, categories} = this.state;

    // Creating array of objects for rendering
    let objectsToRender = [];
    const categoriesArray = _.compact(_.isArray(categories) ? categories : [categories]);
    _.each(categoriesArray, (category) => {
      if (_.includes(this.props.toggles, `subApplication-${category.categoryId}`)) {
        objectsToRender.push({
          id: 'startSubapplication',
          displayName: category.categoryName + ' subapplication',
          link: '/subApplicationInitialize/' + category.categoryId,
          linkDisplay: 'Start subapplication',
        });
      }
    });

    _.each(fundingOpportunities, (fo, index) => {
      // Checking dates
      if (moment().isBetween(fo.aplcnStartDate, fo.aplcnEndDate)) {
        objectsToRender.push({
          id: 'startNewGrant' + index,
          displayName: fo.fundingOpportunityName + ' application',
          link: '/applicationInitialize/' + fo.fundingOpportunityId, // may change
          linkDisplay: 'Start application',
          aplcnStartDate: ISOToDisplayDate(fo.aplcnStartDate, {
            showDate: true,
            showHours: false,
          }),
          aplcnEndDate: ISOToDisplayDate(fo.aplcnEndDate, {
            showDate: true,
            showHours: false,
          }),
        });
      }
    });
    objectsToRender = _.sortBy(objectsToRender, 'displayName');

    let textToRender = '';
    if (!objectsToRender.length) {
      textToRender = 'Currently there are no open application periods.';
    }

    return (
      <Grid.Column id="new-grant-wrapper" width={6}>
        <Card fluid>
          <Card.Content>
            <Header as="h3">Apply for a new grant</Header>
            <br />
            <strong>Applications currently available to you</strong>
            <Divider className="hr-line" />
            {loading ? (
              <Loader inline="centered" active>
                Loading...
              </Loader>
            ) : (
              <span>{textToRender}</span>
            )}
            {this.renderObjects(objectsToRender)}
          </Card.Content>
        </Card>
      </Grid.Column>
    );
  }
}

export const mapStateToProps = (state) => {
  return {
    token: state.auth.token,
    permissions: state.auth.permissions,
    toggles: state.toggles.toggles,
  };
};

export const mapDispatchToProps = (dispatch) => ({
  getOrgPrograms: (token) => {
    const action = ApiActions.organizationRelationship.getAllOrganizationProgramsUnrestricted(
      token
    );
    const response = dispatch(action);
    return response.then((res) => {
      res.hasResults =
        res.type === API_ORG_PROGRAM_GET_SUCCESS && !_.isEmpty(res.payload);
      return res;
    });
  },
  getProgramInfo: (token, params) => {
    const action = ApiActions.program.getProgramList(token, params);
    const response = dispatch(action);
    return response.then((res) => {
      res.hasResults =
        res.type === API_PROGRAM_LIST_GET_SUCCESS && !_.isEmpty(res.payload);
      return res;
    });
  },
  getSuborgOrgPrograms: (token) => {
    const action = ApiActions.organizationRelationship.getSuborgOrgPrograms(token);
    const response = dispatch(action);
    return response.then((res) => {
      res.hasResults =
        res.type === API_SUBORG_ORG_PROGRAM_GET_SUCCESS && !_.isEmpty(res.payload);
      return res;
    });
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(ApplyNewGrantCard);
